export default __webpack_public_path__ + "static/media/hero-verification-failed.cd258fe8.svg";